import { render, staticRenderFns } from "./AddisAbaba.vue?vue&type=template&id=b0f7a828&"
import script from "./AddisAbaba.vue?vue&type=script&lang=js&"
export * from "./AddisAbaba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports